<router-outlet></router-outlet>

<div kendoDialogContainer></div>

<div *ngIf="isLoading$ | async" class="loader-block overlay">
  <app-loader></app-loader>
</div>
